import api from '../../api'
import * as types from '../../types'

export default {
  state: {
    financeRepayDate: '',
    financeRepayBalanced: '',
    financeRepayPrincipal: '',
    financeRepayInterest: '',
    financeRepayFee: '',
    financeRepaySum: '',
    bankAccountInfo: '',
    pageCount: '',
    repayRecordList: []
  },
  getters: {
    [types.GET_NO_REPAY_DETAIL] (state) {
      return {
        financeRepayDate: state.financeRepayDate,
        financeRepayBalanced: state.financeRepayBalanced,
        financeRepayPrincipal: state.financeRepayPrincipal,
        financeRepayInterest: state.financeRepayInterest,
        financeRepayFee: state.financeRepayFee,
        financeRepaySum: state.financeRepaySum,
        bankAccountInfo: state.bankAccountInfo,
        repayRecordList: state.repayRecordList,
        pageCount: state.pageCount
      }
    }
  },
  actions: {
    [types.GET_REPAY_PLAN_INFO]: ({commit}, params) => api.getRepayPlanDetail(params)
  },
  mutations: {
    [types.SET_NO_REPAY_DETAIL] (state, data) {
      state.financeRepayDate = data.financeRepayDate
      state.financeRepayBalanced = data.financeRepayBalanced
      state.financeRepayPrincipal = data.financeRepayPrincipal
      state.financeRepayInterest = data.financeRepayInterest
      state.financeRepayFee = data.financeRepayFee
      state.financeRepaySum = data.financeRepaySum
      state.bankAccountInfo = data.bankAccountInfo
      state.pageCount = data.pageCount
      state.repayRecordList = data.receiptInfoList
    }
  }
}



// WEBPACK FOOTER //
// ./src/vuex/modules/personalCenter/repaymentInfo.js